var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33268 1.99935C9.33268 2.73573 8.73573 3.33268 7.99935 3.33268C7.26297 3.33268 6.66602 2.73573 6.66602 1.99935C6.66602 1.26297 7.26297 0.666016 7.99935 0.666016C8.73573 0.666016 9.33268 1.26297 9.33268 1.99935Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 1.99935C2.66667 2.73573 2.06971 3.33268 1.33333 3.33268C0.596954 3.33268 9.047e-08 2.73573 5.82819e-08 1.99935C2.60937e-08 1.26297 0.596954 0.666016 1.33333 0.666016C2.06971 0.666016 2.66667 1.26297 2.66667 1.99935Z",
    fill: "#1F1F1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 1.99935C16.0007 2.73573 15.4037 3.33268 14.6673 3.33268C13.9309 3.33268 13.334 2.73573 13.334 1.99935C13.334 1.26297 13.9309 0.666016 14.6673 0.666016C15.4037 0.666016 16.0007 1.26297 16.0007 1.99935Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.8a5b18f9f22f9a8e63863d9485cdf209.svg";
export { ForwardRef as ReactComponent };